import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const AgentAccountInfoComponent = ({ accounts, onInnerFormChange, selectedAgents }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="PersonAccount"
              name="IsPersonAccount"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'Account.IsPersonAccount',
                  selectedAgents?.Account
                )
              }}
              type="checkbox"
              value={selectedAgents?.Account?.IsPersonAccount}
          />
       <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Account.Name',
                  selectedAgents?.Account
                )
              }}
              type="text"
              value={selectedAgents?.Account?.Name}
          />
           <InputContainer
              label="Number Of Employees"
              name="NumberOfEmployees"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Account.NumberOfEmployees',
                  selectedAgents?.Account
                )
              }}
              type="number"
              value={selectedAgents?.Account?.NumberOfEmployees}
          />
    <InputContainer
                        label="Account"
                        labelField="Name"
                        list={accounts}
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'Account.AccountId',
                                selectedAgents?.Account
                            )
                        }}
                        type="select"
                        value={selectedAgents?.Account?.AccountId}
                        valueField="Id"
                    />
   
    </div>
 }
 expandedPanel="accountInfo"
 headerTitle="Account Info"
/>
</>
)
export default AgentAccountInfoComponent;
